import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

import errorReducer from "../features/error/errorSlice";
import jobOffersReducer from "../features/joboffers/joboffersSlice";

export const store = configureStore({
  reducer: {
    error: errorReducer,
    jobOffers: jobOffersReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
